module.exports = __webpack_public_path__ + "img/restart_gateway.f1367.png";